module.exports = __webpack_public_path__ + "img/right_engine.4eea741d.png";